import { z } from 'zod'
import { defineChannel } from './realtime-channel.types'
import { ProjectEditorSchema } from '../schemas/project-editor'

export const projectEditorUserChannel = defineChannel({
  channel: (p: { projectId: string; userId: string }) => `project:${p.projectId}:editor:user:${p.userId}`,
  events: {
    'project.edit.approved': {
      // The active editor
      schema: ProjectEditorSchema,
    },
    'project.edit.requested': {
      // The pending editor
      schema: z.object({
        pendingEditor: ProjectEditorSchema,
        autoApproveAt: z.string().datetime(),
      }),
    },
    'project.edit.rejected': {
      schema: z.undefined(),
    },
  },
})

export const projectEditorChannel = defineChannel({
  channel: (p: { projectId: string }) => `project:${p.projectId}:editor`,
  events: {
    'project.edit.updated': {
      // The active editor
      schema: ProjectEditorSchema,
    },
  },
})
